import { useState } from 'react'

import Button from 'src/ui/atoms/Button'
import ConfirmationModal from 'src/ui/atoms/ConfirmationModal'

import useNotificationsApi from './useNotificationsApi'

const RemoveNotification = ({ id, onSuccess }: { id: number; onSuccess: Function }) => {
  const [modal, setModal] = useState<boolean>(false)

  const { removeNotification } = useNotificationsApi()

  const handleRemove = async () => {
    if (modal) {
      await removeNotification(id)

      setModal(false)
      onSuccess()
    }
  }

  return (
    <>
      <span
        className="icon-close cursor-pointer text-lg text-red"
        onClick={() => setModal(true)}></span>
      {modal && (
        <ConfirmationModal
          title="Are you sure you want to delete this notification?"
          actions={
            <>
              <Button size="M" name="Cancel" type="secondary" onClick={() => setModal(false)} />
              <Button size="M" name="Delete" onClick={handleRemove} />
            </>
          }
        />
      )}
    </>
  )
}

export default RemoveNotification
